/* eslint-disable no-secrets/no-secrets */
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
// import PolicyDetailsPage from 'ent-capability-quoteandbind-common-react/pages/PolicyDetails/PolicyDetailsPage.jsx';
import TWIAPropertyDetailsPage from 'twia-capability-quoteandbind-residential-react/pages/PropertyDetails/PropertyDetailsPage.jsx';
import { PaymentDetailsPage } from "twia-capability-policychange-common-react/index.js";
import TWIAEffectiveDatePage from './pages/EffectiveDate/EffectiveDate.jsx';
import TWIAConstruction from 'twia-capability-quoteandbind-residential-react/pages/Construction/ConstructionPage.jsx';
import TWIAQuotePage from 'twia-capability-quoteandbind-residential-react/pages/Quote/QuotePage.jsx';
import CoverageSummaryPage from './pages/CoverageSummary/CoverageSummaryPage.jsx';
import AdditionalInformationPage from './pages/AdditionalInformation/AdditionalInformationPage.jsx';
import PolicyDetailsPage from './pages/PolicyChangeDetails/PolicyChangeDetails.jsx';
// Dummy Pages

setComponentMapOverrides(
    {
        TWIAEffectiveDatePage: { component: 'TWIAEffectiveDatePage' },
        TWIAChangePropertyDetails: { component:  'TWIAChangePropertyDetails' },
        TWIAConstruction: { component: 'TWIAConstruction' },
        TWIAChangeQuotePage: { component: 'TWIAChangeQuotePage' },
        AdditionalInformationPage: { component: 'AdditionalInformationPage' },
        CoverageSummaryPage: { component: 'CoverageSummaryPage' },
        TWIAChangePaymentDetails: { component: 'TWIAChangePaymentDetails' },
        PolicyDetailsPage: { component: 'PolicyDetailsPage'}

    },
    {
        TWIAEffectiveDatePage: TWIAEffectiveDatePage,
        TWIAChangePropertyDetails: TWIAPropertyDetailsPage,
        TWIAConstruction: TWIAConstruction,
        TWIAChangeQuotePage: TWIAQuotePage,
        AdditionalInformationPage: AdditionalInformationPage,
        CoverageSummaryPage: CoverageSummaryPage,
        TWIAChangePaymentDetails: PaymentDetailsPage,
        PolicyDetailsPage: PolicyDetailsPage
    }
)

export { default as TWIAResidentialChangeWizard } from './TWIAResidentialChangeWizard.jsx';
